export default __webpack_public_path__ + "media/react/organisms/video_player/assets/magoosh-d7b96c244a200efc93118fa9df028a01.svg";